import { EVoteReason, EPostStatus, ESectionTrackStatus, EUserFirstStep } from '@constants';

export const StudentDashboardTranslations = {
  SEE_ALL_COURSES: {
    es: 'Ver todos los cursos',
    en: 'See all courses',
    cat: 'Veure tots els cursos',
    eus: 'Ikusi guztiak ikastaroak',
    pt: 'Ver todos os cursos'
  },
  START_COURSE: {
    es: 'Empezar curso',
    en: 'Start course',
    cat: 'Començar el curs',
    eus: 'Ikastaro hasi',
    pt: 'Iniciar curso'
  },
  CONTINUE_COURSE: {
    es: 'Seguir con el curso',
    en: 'Continue course',
    cat: 'Continuar el curs',
    eus: 'Jarraitu ikastaroa',
    pt: 'Continuar curso'
  },
  VIEW_COURSE: {
    es: 'Ver curso',
    en: 'View course',
    cat: 'Ver el curs',
    eus: 'Ikusi ikastaroa',
    pt: 'Ver curso'
  },

  START_HERE: {
    es: 'Empieza por aquí',
    en: 'Start here',
    cat: 'Comença aquí',
    eus: 'Hemen hasi',
    pt: 'Comece aqui'
  },
  PENDING_MESAGES_one: {
    es: '1 no leído',
    en: '1 unread message',
    cat: '1 missatge sense llegir',
    eus: '1 irakurri gabeko mezu',
    pt: '1 mensagem não lida'
  },
  PENDING_MESAGES_other: {
    es: '{{count}} no leídos',
    en: '{{count}} unread messages',
    cat: '{{count}} missatges sense llegir',
    eus: '{{count}} irakurri gabeko mezuak',
    pt: '{{count}} mensagens não lidas'
  },
  EDIT_PROFILE: {
    es: 'Editar perfil',
    en: 'Edit profile',
    cat: 'Editar perfil',
    eus: 'Profila editatu',
    pt: 'Editar perfil'
  },
  MARK_MESSAGE_AS_READ: {
    es: 'Marcar como leído',
    en: 'Mark as read',
    cat: 'Marcar com a llegit',
    eus: 'Markatuta',
    pt: 'Marcar como lido'
  },
  OPEN_CHAT: {
    es: 'Abrir chat',
    en: 'Open chat',
    cat: 'Obrir chat',
    eus: 'Chata ireki',
    pt: 'Abrir chat'
  },
  ALL_TOPICS: {
    es: 'Todas',
    en: 'All',
    cat: 'Tots',
    eus: 'Guztiak',
    pt: 'Todos'
  },
  HI_STUDENT: {
    es: 'Hola, {{name}} 👋',
    en: 'Hi {{name}} 👋',
    cat: 'Hola, {{name}} 👋',
    eus: 'Kaixo {{name}} 👋',
    pt: 'Olá, {{name}} 👋'
  },
  NEWS: {
    es: 'Noticias',
    en: 'News',
    cat: 'Notícies',
    eus: 'Berriak',
    pt: 'Notícias'
  },
  COURSES: {
    es: 'Cursos',
    en: 'Courses',
    cat: 'Cursos',
    eus: 'Ikastaroak',
    pt: 'Cursos'
  },
  SEE_ALL: {
    es: 'Ver todos',
    en: 'See all',
    cat: 'Veure tots',
    eus: 'Ikusi guztiak',
    pt: 'Ver todos'
  },
  FILES: {
    es: 'Archivos',
    en: 'Files',
    cat: 'Fitxers',
    eus: 'Fitxategiak',
    pt: 'Ficheiros'
  },
  NO_NEWS_TO_SHOW: {
    es: 'No hay noticias para mostrar.',
    en: 'No news to show.',
    cat: 'No hi ha notícies per mostrar.',
    eus: 'Ez dago albisterik erakusteko.',
    pt: 'Não há notícias para mostrar.'
  },
  STATS: {
    es: 'Estadísticas',
    en: 'Stats',
    cat: 'Estadístiques',
    eus: 'Estatistikak',
    pt: 'Estatísticas'
  },

  [EPostStatus.PUBLISHED]: {
    es: 'Publicado',
    en: 'Published',
    cat: 'Publicat',
    eus: 'Argitaratua',
    pt: 'Publicado'
  },

  MY_EXAM_GROUPS: {
    es: 'Convocatorias',
    en: 'Exam groups',
    cat: 'Convocatòries',
    eus: 'Azterketa taldeak',
    pt: 'Grupos de exames'
  },
  QUIZZES: {
    es: 'Tests',
    en: 'Tests',
    cat: 'Proves',
    eus: 'Probatzak',
    pt: 'Provas'
  },

  NOT_PROBABLE: {
    es: 'No lo recomendaría',
    en: 'I would not recommend it',
    cat: 'No recomanaria',
    eus: 'Ez da inoiz egin',
    pt: 'Não recomendo'
  },
  VERY_PROBABLE: {
    es: 'Lo recomendaría',
    en: 'I would recommend it',
    cat: 'Recomanaría',
    eus: 'Egin behar duzu egin',
    pt: 'Recomendo'
  },
  NEXT: {
    es: 'Siguiente',
    en: 'Next',
    cat: 'Següent',
    eus: 'Hurrengoa',
    pt: 'Próximo'
  },
  BACK: {
    es: 'Atrás',
    en: 'Back',
    cat: 'Enrere',
    eus: 'Atzera',
    pt: 'Voltar'
  },
  WRITE_HERE: {
    es: 'Escribe aquí...',
    en: 'Write here...',
    cat: 'Escriu aquí...',
    eus: 'Idatzi hemen...',
    pt: 'Escreva aqui...'
  },
  POST_NPS_NEUTRAL_TITLE: {
    es: '¡Gracias!',
    en: 'Thank you!',
    cat: 'Gràcies!',
    eus: 'Eskerrik asko!',
    pt: 'Obrigado!'
  },
  POST_NPS_NEUTRAL_SUBTITLE: {
    es: 'Trabajaremos en esos pequeños detalles para convertir tu nota en un 10.',
    en: 'We will work on those small details to convert your note into a 10.',
    cat: 'Treurem en compte aquests petits detalls per convertir la teva nota en un 10.',
    eus: 'Zure puntuazioa 10 egin nahi duen txikiek detaldeak kontuan hartuko dizkizkiz.',
    pt: 'Vamos trabalhar nesses pequenos detalhes para converter a sua nota em um 10.'
  },
  POST_NPS_PROMOTER_TITLE: {
    es: 'Tu opinión vale oro',
    en: 'Your opinion is gold',
    cat: 'La teva opinió val or',
    eus: 'Zure iruzkinak oro balio du',
    pt: 'Sua opinião vale ouro'
  },
  POST_NPS_PROMOTER_SUBTITLE: {
    es: '¿Nos dejas una reseña en Trustpilot?',
    en: 'Leave us a review on Trustpilot.',
    cat: 'Deixa-nos una ressenya a Trustpilot.',
    eus: 'Zure Trustpilot-en iruzkin bat utzi, mesedez.',
    pt: 'Sua opinião no Trustpilot vale ouro.'
  },
  POST_NPS_PROMOTER_SUBTITLE_2: {
    es: '¡Nos haría mucha ilusión leerte!',
    en: 'It would make us very happy to read your opinion.',
    cat: 'Ens faria molta il·lusió llegir la teva opinió.',
    eus: 'Gurekin harremanetan jarriko gara zure iruzkinaren emaitza gurekin.',
    pt: 'Gostaríamos muito de ler a sua opinião.'
  },
  POST_NPS_DETRACTOR_TITLE: {
    es: 'Tendremos en cuenta tu opinión',
    en: 'We will take your opinion into account',
    cat: 'Tindrem en compte la teva opinió',
    eus: 'Zure iruzkinak kontuan hartuko dizkizkiz',
    pt: 'Vamos ter em conta a sua opinião'
  },
  POST_NPS_DETRACTOR_SUBTITLE: {
    es: 'Valoraremos tus comentarios para convertir Ucademy en lo que TÚ quieres. ',
    en: 'We will value your comments to make Ucademy what YOU want.',
    cat: 'Valorarem els teus comentaris per fer Ucademy el que TÚ vols.',
    eus: 'Zure iruzkinak kontuan hartuko dizkizkiz Ucademy egin nahi duzun moduan.',
    pt: 'Valoraremos os seus comentários para tornar o Ucademy no que você quer.'
  },
  POST_NPS_DETRACTOR_SUBTITLE_2: {
    es: '¡Suerte y ánimo con el estudio!',
    en: 'Good luck and good study!',
    cat: 'Bon viatge i bons estudis!',
    eus: 'Ez zituen eta ezinbesteko ikastarok.',
    pt: 'Boa sorte e bom estudo!'
  },
  CLICK_HERE: {
    es: 'Haz click aquí 😁',
    en: 'Click here 😁',
    cat: 'Fes clic aquí 😁',
    eus: 'Klik egin hemen 😁',
    pt: 'Clique aqui 😁'
  },
  REGULAR_NPS_DETRACTOR_TITLE: {
    es: '¿Nos puedes contar que no te ha gustado?',
    en: 'Can you tell us what you did not like?',
    cat: 'Ens pots dir què no t’ha agradat?',
    eus: 'Esan dezakezu zer ez zait gustatu?',
    pt: 'Pode nos dizer o que não gostou?'
  },
  REGULAR_NPS_NEUTRAL_TITLE: {
    es: '¿Qué tendríamos que mejorar para que la próxima sea un 10?',
    en: 'What should we improve to get a 10 next time?',
    cat: 'Què hauríem de millorar perquè la propera sigui un 10?',
    eus: 'Zer hobetu behar genuke hurrengoan 10 bat jartzeko?',
    pt: 'O que deveríamos melhorar para obter um 10 na próxima vez?'
  },
  REGULAR_NPS_PROMOTER_TITLE: {
    es: '¿Qué es lo que más valoras de Ucademy?',
    en: 'What do you value most about Ucademy?',
    cat: 'Què és el que més valores de Ucademy?',
    eus: 'Zer baloratzen duzu gehien Ucademyren?',
    pt: 'O que valoriza mais em Ucademy?'
  },

  [`${EVoteReason.OTHER}`]: {
    es: 'Otro',
    en: 'Other',
    cat: 'Un altre',
    eus: 'Beste',
    pt: 'Outro'
  },
  [`${EVoteReason.VIDEO_CONTENT}`]: {
    es: 'Calidad del contenido (vídeos)',
    en: 'Content quality (videos)',
    cat: 'Qualitat del contingut (vídeos)',
    eus: 'Edukia bideo formatuan',
    pt: 'Conteúdo em formato de vídeo'
  },
  [`${EVoteReason.STUDY_MATERIAL}`]: {
    es: 'Material descargable (apuntes)',
    en: 'Downloadable study material (notes)',
    cat: 'Material descarregable (apunts)',
    eus: 'Deskargatu daitekeen materiala (oharrak)',
    pt: 'Material descargável (apontamentos)'
  },
  [`${EVoteReason.TEACHER_MONITORING}`]: {
    es: 'Seguimiento del profesorado',
    en: 'Teaching staff follow-up',
    cat: 'Seguiment del professorat',
    eus: 'Ikaslearen arreta taldea',
    pt: 'Acompanhamento do corpo docente'
  },

  [`${EVoteReason.INCOMPLETE_SYLLABUS}`]: {
    es: 'Temario incompleto',
    en: 'Incomplete syllabus',
    cat: 'Temari incomplet',
    eus: 'Programa osatugabea',
    pt: 'Programa incompleto'
  },
  [`${EVoteReason.LIVE_CLASSES}`]: {
    es: 'Clases en directo',
    en: 'Live classes',
    cat: 'Classes en directe',
    eus: 'Klaseak zuzenean',
    pt: 'Aulas ao vivo'
  },
  [`${EVoteReason.QUIZZES_QUANTITY}`]: {
    es: 'Más cantidad de tests',
    en: 'More quizzes',
    cat: 'Més proves',
    eus: 'Gehiago quizak',
    pt: 'Mais provas'
  },
  [`${EVoteReason.QUIZZES_QUALITY}`]: {
    es: 'Calidad de los tests',
    en: 'Quiz quality',
    cat: 'Qualitat dels tests',
    eus: 'Quizaren kualitatea',
    pt: 'Qualidade dos testes'
  },
  [`${EVoteReason.QUIZZES_FOR_PRACTICE}`]: {
    es: 'Test para practicar',
    en: 'Quiz for practice',
    cat: 'Prova per practicar',
    eus: 'Proba egin',
    pt: 'Prova para praticar'
  },
  [`${EVoteReason.MORE_QUIZZES_FOR_PRACTICE}`]: {
    es: 'Más tests para practicar',
    en: 'More quizzes for practice',
    cat: 'Més proves per practicar',
    eus: 'Gehiago probak egin',
    pt: 'Mais provas para praticar'
  },
  [`${EVoteReason.PLATFORM_FUNCTIONING}`]: {
    es: 'Funcionamiento de la plataforma',
    en: 'Platform functionality',
    cat: 'Funcionalitat de la plataforma',
    eus: 'Plataformaren funtzionamendua',
    pt: 'Informação insuficiente sobre a plataforma'
  },
  [`${EVoteReason.EXAM_DATES}`]: {
    es: 'Poca información sobre convocatorias',
    en: 'Little information about exams',
    cat: 'Poca informació sobre convocatòries',
    eus: 'Azterketa deiei buruzko informazio gutxi',
    pt: 'Poucas informações sobre ligações'
  },
  [`${EVoteReason.BETTER_CONTENT}`]: {
    es: 'Mejorar el contenido',
    en: 'Improve content',
    cat: 'Improvar el contingut',
    eus: 'Edukia hobetu',
    pt: 'Melhorar o conteúdo'
  },
  [`${EVoteReason.MORE_LIVE_CLASSES}`]: {
    es: 'Más clases en directo',
    en: 'More live classes',
    cat: 'Més classes en directe',
    eus: 'Zuzeneko klase gehiago',
    pt: 'Mais aulas ao vivo'
  },
  [`${EVoteReason.STUDENT_ATTENDANCE}`]: {
    es: 'Atención al alumno',
    en: 'Student support',
    cat: 'Suport al alumne',
    eus: 'Ikasleen arreta',
    pt: 'Suporte ao aluno'
  },
  [`${EVoteReason.TEACHERS}`]: {
    es: 'El profesorado',
    en: 'The teaching staff',
    cat: 'El professorat',
    eus: 'Irakasleak',
    pt: 'Corpo docente'
  },
  [`${EVoteReason.HELP_TO_USE_PLATFORM}`]: {
    es: 'Ayuda para usar la plataforma',
    en: 'Help to use the platform',
    cat: 'Ajuda per utilitzar la plataforma',
    eus: 'Gurekin erabili nahi duzun plataforma baten laguntza',
    pt: 'Ajuda para usar a plataforma'
  },
  [`${EVoteReason.MORE_CLARITY_HOW_TO_STUDY}`]: {
    es: 'Más claridad sobre cómo estudiar',
    en: 'More clarity on how to study',
    cat: 'Més claredat sobre com estudiar',
    eus: 'Ikasteko moduari buruzko argitasun gehiago',
    pt: 'Mais clareza sobre como estudar'
  },
  [`${EVoteReason.METHODS_ORIENTATION}`]: {
    es: 'Orientación sobre qué métodos usar',
    en: 'Orientation on which methods to use',
    cat: 'Orientació sobre quins mètodes utilitzar',
    eus: 'Metodologikoki orientatzea',
    pt: 'Orientação sobre quais métodos usar'
  },
  [`${EVoteReason.PREVIOUS_EXAMS}`]: {
    es: 'Exámenes de años anteriores',
    en: 'Previous years exams',
    cat: 'Proves de anys anteriors',
    eus: 'Aurreko urteetako azterketak',
    pt: 'Exames de anos anteriores'
  },
  [`${EVoteReason.BETTER_GENERAL_CONTENT}`]: {
    es: 'Mejor calidad de contenido',
    en: 'Better content quality',
    cat: 'Més bona qualitat de contingut',
    eus: 'Edukiaren kalitate hobea',
    pt: 'Melhor qualidade de conteúdo'
  },
  [`${EVoteReason.DONT_KNOW_START}`]: {
    es: 'No sé por dónde empezar',
    en: 'I don’t know where to start',
    cat: 'No sé per on començar',
    eus: 'Ez dakit non hasi',
    pt: 'Não sei por onde começar'
  },
  [`${EVoteReason.DONT_KNOW_USE_THE_APP}`]: {
    es: 'No sé cómo usar la plataforma',
    en: 'I don’t know how to use the platform',
    cat: 'No sé com utilitzar la plataforma',
    eus: 'Ez dakit nola erabili zure plataforma',
    pt: 'Não sei como usar a plataforma'
  },
  [`${EVoteReason.DONT_KNOW_ORGANIZE_STUDY}`]: {
    es: 'No sé cómo organizar mi estudio',
    en: 'I don’t know how to organize my study',
    cat: 'No sé com organitzar el meu estudi',
    eus: 'Ez dakit nola antolatu nire ikasketa',
    pt: 'Não sei como organizar o meu estudo'
  },
  [`${EVoteReason.DONT_KNOW_PRACTICE_MODE}`]: {
    es: 'No entiendo los modos de práctica',
    en: 'I don’t understand the practice modes',
    cat: 'No sé com utilitzar els modes de pràctica',
    eus: 'Ez ditut ulertzen praktika moduak',
    pt: 'Não sei como usar os modos de prática'
  },
  [`${EVoteReason.DONT_KNOW_TALK_TO_TUTOR}`]: {
    es: 'No sé cómo hablar con mi tutor',
    en: 'I don’t know how to talk to my tutor',
    cat: 'No sé com parlar amb el meu tutor',
    eus: 'Ez dakit nola hitz egin nire tutorearekin',
    pt: 'Não sei como falar com o meu tutor'
  },
  [`${EVoteReason.DONT_KNOW_SEE_RECORDED_CLASSES}`]: {
    es: 'No sé cómo ver las clases en directo',
    en: 'I don’t know how to see the live classes',
    cat: 'No sé com veure les classes en directe',
    eus: 'Ez dakit nola ikusi klaseak zuzenean.',
    pt: 'Não sei como ver as aulas ao vivo'
  },
  [`${EVoteReason.DONT_KNOW_FOLLOW_EXAMS}`]: {
    es: 'No se como seguir una convocatoria',
    en: 'I don’t know how to follow an exam',
    cat: 'No sé com seguir una convocatòria',
    eus: 'Ez dakit nola jarraitu azterketa bat',
    pt: 'Não sei como seguir uma convocatória'
  },

  WHAT_WILL_YOU_IMPROVE: {
    es: 'Cuéntanos lo que mejorarías',
    en: 'Tell us what you would improve',
    cat: 'Digues-nos què milloraria',
    eus: 'Zer hobetu nahi duzu',
    pt: 'Diga-nos o que melhoraria'
  },
  WOULD_YOU_RECOMMEND_UCADEMY: {
    es: '¿Recomendarías Ucademy a otra persona?',
    en: 'Would you recommend Ucademy to another person?',
    cat: 'Recomanarías Ucademy a una altra persona?',
    eus: 'Zer esan dezakezu Ucademy bat beste pertsorako?',
    pt: 'Recomendaria o Ucademy para outra pessoa?'
  },
  IS_EVERYTHING_CLEAR: {
    es: '¿Tienes claro cómo estudiar con nosotros?',
    en: 'Is everything clear on how to study with us?',
    cat: 'Tens clar com estudiar amb nosaltres?',
    eus: 'Argi daukazu nola ikasi gurekin?',
    pt: 'Tem certeza de como estudar con nós?'
  },
  IS_EVERYTHING_CLEAR_DESCRIPTION: {
    es: 'Queremos que sepas cómo avanzar en tu estudio desde el primer momento.',
    en: 'We want you to know how to advance in your study from the first moment.',
    cat: 'Volem que coneguis com avançar en el teu estudi des del primer moment.',
    eus: 'Gurekin ezinbesteko ikastetxean egiteko modua ezagutu nahi duzu.',
    pt: 'Queremos que saiba como avançar no seu estudo desde o primeiro momento.'
  },
  YES: {
    es: '👍 Sí',
    en: '👍 Yes',
    cat: '👍 Sí',
    eus: '👍 Bai',
    pt: '👍 Sim'
  },
  NO: {
    es: '👎 No',
    en: '👎 No',
    cat: '👎 No',
    eus: '👎 Ei',
    pt: '👎 Não'
  },
  ONBOARDING_NPS_PROMOTER_TITLE: {
    es: '😄 ¡Guay! ¿Qué es lo que más te ha gustado en tus primeros días?',
    en: '😄 Great! What did you like the most in your first days?',
    cat: '😄 Guau! Què t’ha agradat més en els teus primers dies?',
    eus: '😄 Guay! Zer gustatu zaizu gehien zure lehenengo egunetan?',
    pt: '😄 Ótimo! O que mais gostou nos seus primeiros dias?'
  },
  ONBOARDING_NPS_DETRACTOR_TITLE: {
    es: '🤔 ¿Qué faltó para que tu experiencia fuera excelente?',
    en: '🤔 What was missing to make your experience excellent?',
    cat: '🤔 Què faltava per fer que la teva experiència fos excel·lent?',
    eus: '🤔 Zer falta zituen zure ikastetxearen eragiketak egon zehatzago?',
    pt: '🤔 O que faltava para que a sua experiência fosse excelente?'
  },
  WHAT_DO_YOU_NOT_UNDERSTAND: {
    es: '🙁 Lo sentimos. ¿Qué es lo que no tienes claro?',
    en: '🙁 We are sorry. What do you not understand?',
    cat: '🙁 Ho sentim. Què no tens clar?',
    eus: '🙁 Gurek esan nahi duena, zer ez duzu argi?',
    pt: '🙁 Sentimos muito. O que não compreende?'
  },

  SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Enviar',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  THANKS_FOR_YOUR_FEEDBACK: {
    es: '¡Gracias por tu valoración!',
    en: 'Thank you for your rating!',
    cat: 'Gràcies per la teva valoració!',
    eus: 'Zerindu zure ordena!',
    pt: 'Obrigado pela sua avaliação!'
  },
  YOU_SOMETHING_TO_SAY: {
    es: '¿Tienes algo que destacar o mejorar en esta clase?',
    en: 'Do you have something to highlight or improve in this class?',
    cat: '¿Tens alguna cosa que destacar o millorar en aquesta classe?',
    eus: 'Zer duzu zerbait argitaratu edo hobetu zenuen klasean?',
    pt: 'Tem algo para destacar ou melhorar nesta aula?'
  },
  WRITE_YOUR_COMMENT: {
    es: 'Escribe tu comentario...',
    en: 'Write your comment...',
    cat: 'Escriu el teu comentari...',
    eus: 'Idatzi zure iruzkin hau...',
    pt: 'Escreva o seu comentário...'
  },
  CANCEL: {
    es: 'Cancelar',
    en: 'Cancel',
    cat: 'Cancel·lar',
    eus: 'Utzi',
    pt: 'Cancelar'
  },
  CHAT_WIDGET_TITLE: {
    es: 'Chat con tutor',
    en: 'Chat with tutor',
    cat: 'Chat amb tutor',
    eus: 'Ikastetxearen tutorarekin harremanetan',
    pt: 'Chat com o tutor'
  },
  NO_MESSAGES: {
    es: 'No hay nuevos mensajes',
    en: 'No new messages',
    cat: 'No hi ha nous missatges',
    eus: 'Ez dago mezu berriak',
    pt: 'Não há novos mensagens'
  },
  POST_TAGS_COUNT_one: {
    es: '{{count}} formación',
    en: '{{count}} training',
    cat: '{{count}} formació',
    eus: '{{count}} ikastetxe',
    pt: '{{count}} formação'
  },
  POST_TAGS_COUNT_other: {
    es: '{{count}} formaciones',
    en: '{{count}} trainings',
    cat: '{{count}} formacions',
    eus: '{{count}} ikastetxeak',
    pt: '{{count}} formações'
  },
  EDIT: {
    es: 'Editar',
    en: 'Edit',
    cat: 'Editar',
    eus: 'Editatu',
    pt: 'Editar'
  },
  POST_CREATED_SUCCESSFULLY: {
    es: 'Post creado correctamente',
    en: 'Post created successfully',
    cat: 'Post creat correctament',
    eus: 'Posta behar bezala sortua',
    pt: 'Post criado com sucesso'
  },
  POST_UPDATED_SUCCESSFULLY: {
    es: 'Post actualizado correctamente',
    en: 'Post updated successfully',
    cat: 'Post actualitzat correctament',
    eus: 'Posta behar bezala eguneratua',
    pt: 'Post atualizado com sucesso'
  },
  POST_DELETED_SUCCESSFULLY: {
    es: 'Post eliminado correctamente',
    en: 'Post deleted successfully',
    cat: 'Post eliminat correctament',
    eus: 'Posta behar bezala ezabatua',
    pt: 'Post eliminado com sucesso'
  },
  TOPIC_CREATED_SUCCESSFULLY: {
    es: 'Tema creado correctamente',
    en: 'Topic created successfully',
    cat: 'Tema creat correctament',
    eus: 'Gai behar bezala sortua',
    pt: 'Tema criado com sucesso'
  },

  TOPIC_REMOVED_SUCCESSFULLY: {
    es: 'Tema eliminado correctamente',
    en: 'Topic removed successfully',
    cat: 'Tema eliminat correctament',
    eus: 'Gai behar bezala ezabatua',
    pt: 'Tema eliminado com sucesso'
  },
  RELATED_POSTS: {
    es: 'Artículos relacionados 👇',
    en: 'Related posts 👇',
    cat: 'Articles relacionats 👇',
    eus: 'Erlazionatutako artikuluak 👇',
    pt: 'Artigos relacionados 👇'
  },
  ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_POST: {
    es: '¿Estás seguro de querer eliminar este post?',
    en: 'Are you sure you want to delete this post?',
    cat: 'Estàs segur de voler eliminar aquest post?',
    eus: 'Zer zaude ziur zaude zerbitzua ezabatu nahi duzula?',
    pt: 'Tem certeza que deseja eliminar este post?'
  },
  STATUS: {
    es: 'Estado',
    en: 'Status',
    cat: 'Estat',
    eus: 'Egoera',
    pt: 'Estado'
  },
  SCHEDULE_POST: {
    es: 'Programar publicación',
    en: 'Schedule post',
    cat: 'Programar publicació',
    eus: 'Posta planifikatu',
    pt: 'Publicar post programado'
  },
  SCHEDULE_POST_DATE: {
    es: 'Fecha',
    en: 'Date',
    cat: 'Data',
    eus: 'Data',
    pt: 'Data'
  },
  SCHEDULE_POST_TIMEZONE: {
    es: 'Zona horaria',
    en: 'Timezone',
    cat: 'Zona horària',
    eus: 'Denbora-zonal',
    pt: 'Fuso horário'
  },
  SCHEDULED_POST: {
    es: 'Programado',
    en: 'Scheduled',
    cat: 'Programat',
    eus: 'Planifikatua',
    pt: 'Programado'
  },
  PUBLISHED_POST: {
    es: 'Publicado',
    en: 'Published',
    cat: 'Publicat',
    eus: 'Argitaratua',
    pt: 'Publicado'
  },
  CREATE_NEWS: {
    es: 'Crear noticia',
    en: 'Create news',
    cat: 'Crear notícia',
    eus: 'Berri sortu',
    pt: 'Criar notícia'
  },
  EDIT_NEWS: {
    es: 'Editar noticia',
    en: 'Edit news',
    cat: 'Editar notícia',
    eus: 'Berriaren editatu',
    pt: 'Editar notícia'
  },
  PUBLISH_NEWS: {
    es: 'Publicar',
    en: 'Publish',
    cat: 'Publicar',
    eus: 'Argitaratu',
    pt: 'Publicar'
  },
  SAVE_CHANGES: {
    es: 'Guardar cambios',
    en: 'Save changes',
    cat: 'Guardar canvis',
    eus: 'Aldatuak gorde',
    pt: 'Guardar alterações'
  },
  SAVE_DRAFT: {
    es: 'Guardar borrador',
    en: 'Save draft',
    cat: 'Guardar borrador',
    eus: 'Gorde zuzendua',
    pt: 'Guardar rascunho'
  },
  DRAFT_POST: {
    es: 'Borrador',
    en: 'Draft',
    cat: 'Borrador',
    eus: 'Zuzendua',
    pt: 'Rascunho'
  },
  FEATURED_NEWS: {
    es: 'Noticia destacada',
    en: 'Featured news',
    cat: 'Notícia destacada',
    eus: 'Berri argitaratua',
    pt: 'Notícia destacada'
  },
  FEATURE_POST: {
    es: 'Publicar como destacada',
    en: 'Publish as featured',
    cat: 'Publicar com a destacada',
    eus: 'Argitaratu berri zehaztasuneko atala bezala',
    pt: 'Publicar como notícia destacada'
  },
  FEATURE_POST_TOOLTIP: {
    es: 'La noticia destacada aparece fija en la sección de noticias.',
    en: 'The featured post appears fixed in the news section.',
    cat: 'La notícia destacada apareix fixa en la secció de notícies.',
    eus: 'Berri argitaratua zehaztasuneko atala erakusten da.',
    pt: 'A notícia destacada aparece fixa na secção de notícias.'
  },
  NO_TAGS_SELECTED_ALERT: {
    es: 'No has seleccionado ninguna formación. Si no seleccionas ninguna, esta noticia se considerará como una noticia global, por lo que todos los alumnos la verán.',
    en: 'If you do not select any training, this news will be considered as a global news, so all students will see it.',
    cat: 'Si no selecciones cap formació, aquesta notícia es considerarà com a notícia global, per la qual cosa tots els alumnes la veuran.',
    eus: 'Ez baduzu ikastetxe bat hautatu, berria globala izango da, eta guztiak ikusi dituzte.',
    pt: 'Se não selecionar nenhuma formação, a notícia será considerada como uma notícia global, e todos os alunos a verão.'
  },
  DOWNLOAD_LIVE_CLASS_VOTE: {
    es: 'Descargar votos de clases en directo',
    en: 'Download live class votes',
    cat: 'Descargar votos de classes en directe',
    eus: 'Ekitaldi-klaseen ordenak deskargatu',
    pt: 'Descarregar votos de aulas ao vivo'
  },
  SEND_EMAIL_NOTIFICATION: {
    es: 'Enviar notificación por email',
    en: 'Send email notification',
    cat: 'Enviar notificació per email',
    eus: 'Posta elektronikoan jakinarazpen bidali',
    pt: 'Enviar notificação por email'
  },
  SEND_EMAIL_NOTIFICATION_TOOLTIP: {
    es: 'Si seleccionas esta opción, el post se enviará por email a todos los alumnos que tengan las formaciones seleccionadas. Si la noticia esta programada, se enviará a los alumnos el día que se publique.',
    en: 'If you select this option, the post will be sent by email to all students who have the selected trainings. If the news is scheduled, it will be sent to the students the day it is published.',
    cat: 'Si selecciones aquesta opció, el post es enviarà per email a tots els alumnes que tinguin les formations seleccionades. Si la notícia esta programada, es enviarà a tots els alumnes el dia que es publiqui.',
    eus: 'Aukera hau hautatzen baduzu, hautatutako prestakuntza duten ikasle guztiei bidaliko zaie posta elektronikoz. Albistea programatuta badago, argitaratzen den egunean bidaliko zaie ikasleei.',
    pt: 'Se selecionar esta opção, o post será enviado por email a todos os alunos que têm as formações selecionadas. Se a notícia estiver programada, será enviada aos alunos no dia que for publicada.'
  },
  CONTACT_WIDGET_TITLE: {
    es: 'Contacta con tu asesor',
    en: 'Contact your advisor',
    cat: 'Contacta amb el teu assessor',
    eus: 'Zure asesorarekin harremanetan',
    pt: 'Contate seu assessor'
  },
  SCORE_MOBILE_SUBTITLE_BAD: {
    es: '0-6: No lo recomendaría, necesita mejorar',
    en: '0-6: I would not recommend it, it needs improvement',
    cat: '0-6: No recomanaria, necessita millorar',
    eus: '0-6: Ez da inoiz egin, behar duzu hobetu',
    pt: '0-6: Não recomendo, precisa melhorar'
  },
  SCORE_MOBILE_SUBTITLE_MIDDLE: {
    es: '7-8: Tiene margen de mejora',
    en: '7-8: It has room for improvement',
    cat: '7-8: Té marge per millorar',
    eus: '7-8: Egin behar duzu hobetu',
    pt: '7-8: Tem margem para melhorar'
  },
  SCORE_MOBILE_SUBTITLE_GOOD: {
    es: '9-10: Lo recomendaría',
    en: '9-10: I would recommend it',
    cat: '9-10: Recomanaría',
    eus: '9-10: Egin behar duzu egin',
    pt: '9-10: Recomendo'
  },
  GO_TO_PRACTICE: {
    es: 'Ir a practicar',
    en: 'Go to practice',
    cat: 'Ir a practicar',
    eus: 'Egin praktika',
    pt: 'Ir para prática'
  },
  WIDGET_TEST_DESCRIPTION: {
    es: 'Elige un modo de práctica y demuestra todo lo que has aprendido.',
    en: 'Choose a practice mode and show everything you’ve learned.',
    cat: 'Tria un mode de pràctica i demostra tot el que has après.',
    eus: 'Aukeratu praktika-modu bat eta erakutsi ikasitako guztia.',
    pt: 'Escolha um modo de prática e mostre tudo o que aprendeu.'
  },
  MAKE_A_TEST: {
    es: 'Haz un test',
    en: 'Make a test',
    cat: 'Fes un test',
    eus: 'Egin test bat',
    pt: 'Faça um teste'
  },
  EMPTY_QUIZZES_TITLE: {
    es: 'Practica con tests',
    en: 'Practice with tests',
    cat: 'Practica amb proves',
    eus: 'Praktika test batzuk erabiltzen',
    pt: 'Pratique com testes'
  },
  EMPTY_QUIZZES_DESCRIPTION: {
    es: 'Elige un modo de práctica y descubre cuánto sabes.',
    en: 'Choose a practice mode and discover how much you know.',
    cat: 'Tria un mode de pràctica i descobreix quant sabeu.',
    eus: 'Aukeratu praktika-modu bat eta ezagutu zenbat ezagutzen duzun.',
    pt: 'Escolha um modo de prática e descubra quanto sabe.'
  },
  GO_TO_HISTORY: {
    es: 'Ver historial',
    en: 'View history',
    cat: 'Veure historial',
    eus: 'Ikusi historia',
    pt: 'Ver histórico'
  },
  NEW_TEST: {
    es: 'Nuevo test',
    en: 'New test',
    cat: 'Nou test',
    eus: 'Test berria',
    pt: 'Novo teste'
  },
  DO_A_QUIZ: {
    es: 'Hacer un test',
    en: 'Make a test',
    cat: 'Fes un test',
    eus: 'Egin test bat',
    pt: 'Faça um teste'
  },
  DO_A_QUIZ_DESCRIPTION: {
    es: 'Sigue poniendo a prueba cuánto sabes.',
    en: 'Keep testing how much you know.',
    cat: 'Continua provant quant sabeu.',
    eus: 'Jarraitu ezagutu zenbat ezagutzen duzun.',
    pt: 'Continue testando quanto sabe.'
  },
  TASKS: {
    es: 'Tareas',
    en: 'Tasks',
    cat: 'Tasques',
    eus: 'Eginak',
    pt: 'Tarefas'
  },

  WEEKDAY_MON: {
    es: 'Lun',
    en: 'Mon',
    cat: 'Dil',
    eus: 'Asl',
    pt: 'Seg'
  },
  WEEKDAY_TUE: {
    es: 'Mar',
    en: 'Tue',
    cat: 'Dim',
    eus: 'Ast',
    pt: 'Ter'
  },
  WEEKDAY_WED: {
    es: 'Mié',
    en: 'Wed',
    cat: 'Dim',
    eus: 'Azk',
    pt: 'Qua'
  },
  WEEKDAY_THU: {
    es: 'Jue',
    en: 'Thu',
    cat: 'Dij',
    eus: 'Ost',
    pt: 'Qui'
  },
  WEEKDAY_FRI: {
    es: 'Vie',
    en: 'Fri',
    cat: 'Div',
    eus: 'Orl',
    pt: 'Sex'
  },
  WEEKDAY_SAT: {
    es: 'Sáb',
    en: 'Sat',
    cat: 'Dis',
    eus: 'Lar',
    pt: 'Sáb'
  },
  WEEKDAY_SUN: {
    es: 'Dom',
    en: 'Sun',
    cat: 'Diu',
    eus: 'Igd',
    pt: 'Dom'
  },

  TODAY: {
    es: 'Hoy',
    en: 'Today',
    cat: 'Avui',
    eus: 'Gaur',
    pt: 'Hoje'
  },

  MONTH_JANUARY: {
    es: 'enero',
    en: 'January',
    cat: 'gener',
    eus: 'urtarrila',
    pt: 'janeiro'
  },
  MONTH_FEBRUARY: {
    es: 'febrero',
    en: 'February',
    cat: 'febrer',
    eus: 'otsaila',
    pt: 'fevereiro'
  },
  MONTH_MARCH: {
    es: 'marzo',
    en: 'March',
    cat: 'març',
    eus: 'martxoa',
    pt: 'março'
  },
  MONTH_APRIL: {
    es: 'abril',
    en: 'April',
    cat: 'abril',
    eus: 'apirila',
    pt: 'abril'
  },
  MONTH_MAY: {
    es: 'mayo',
    en: 'May',
    cat: 'maig',
    eus: 'maiatza',
    pt: 'maio'
  },
  MONTH_JUNE: {
    es: 'junio',
    en: 'June',
    cat: 'juny',
    eus: 'ekaina',
    pt: 'junho'
  },
  MONTH_JULY: {
    es: 'julio',
    en: 'July',
    cat: 'juliol',
    eus: 'uztaila',
    pt: 'julho'
  },
  MONTH_AUGUST: {
    es: 'agosto',
    en: 'August',
    cat: 'agost',
    eus: 'abuztua',
    pt: 'agosto'
  },
  MONTH_SEPTEMBER: {
    es: 'septiembre',
    en: 'September',
    cat: 'setembre',
    eus: 'iraila',
    pt: 'setembro'
  },
  MONTH_OCTOBER: {
    es: 'octubre',
    en: 'October',
    cat: 'octubre',
    eus: 'urria',
    pt: 'outubro'
  },
  MONTH_NOVEMBER: {
    es: 'noviembre',
    en: 'November',
    cat: 'novembre',
    eus: 'azaroa',
    pt: 'novembro'
  },
  MONTH_DECEMBER: {
    es: 'diciembre',
    en: 'December',
    cat: 'desembre',
    eus: 'abendua',
    pt: 'dezembro'
  },

  WEEKDAY_FULL_MONDAY: {
    es: 'lunes',
    en: 'Monday',
    cat: 'dilluns',
    eus: 'astelehena',
    pt: 'segunda-feira'
  },
  WEEKDAY_FULL_TUESDAY: {
    es: 'martes',
    en: 'Tuesday',
    cat: 'dimarts',
    eus: 'asteartea',
    pt: 'terça-feira'
  },
  WEEKDAY_FULL_WEDNESDAY: {
    es: 'miércoles',
    en: 'Wednesday',
    cat: 'dimecres',
    eus: 'asteazkena',
    pt: 'quarta-feira'
  },
  WEEKDAY_FULL_THURSDAY: {
    es: 'jueves',
    en: 'Thursday',
    cat: 'dijous',
    eus: 'osteguna',
    pt: 'quinta-feira'
  },
  WEEKDAY_FULL_FRIDAY: {
    es: 'viernes',
    en: 'Friday',
    cat: 'divendres',
    eus: 'ostirala',
    pt: 'sexta-feira'
  },
  WEEKDAY_FULL_SATURDAY: {
    es: 'sábado',
    en: 'Saturday',
    cat: 'dissabte',
    eus: 'larunbata',
    pt: 'sábado'
  },
  WEEKDAY_FULL_SUNDAY: {
    es: 'domingo',
    en: 'Sunday',
    cat: 'diumenge',
    eus: 'igandea',
    pt: 'domingo'
  },
  PENDING_DEADLINE_DATE: {
    es: 'Fecha pendiente',
    en: 'Pending date',
    cat: 'Data pendent',
    eus: 'Egunerako data',
    pt: 'Data pendente'
  },
  DAYS: {
    es: 'días',
    en: 'days',
    cat: 'dies',
    eus: 'egun',
    pt: 'dias'
  },
  RANKING_OF: {
    es: 'Ranking de {{month}}',
    en: 'Ranking of {{month}}',
    cat: 'Classificació de {{month}}',
    eus: 'Ranking {{month}}',
    pt: 'Ranking de {{month}}'
  },
  SEE_RANKING: {
    es: 'Ver ranking',
    en: 'See ranking',
    cat: 'Veure classificació',
    eus: 'Ikusi ranking',
    pt: 'Ver ranking'
  },
  ENTER_RANKING: {
    es: 'Entra en el ranking',
    en: 'Enter the ranking',
    cat: 'Entrar a la classificació',
    eus: 'Ikusi ranking',
    pt: 'Ver ranking'
  },
  GET_POINTS_TO_BE_IN_THE_RANKING: {
    es: 'Consigue 20 puntos para entrar en el ranking de {{courseName}}',
    en: 'Get 20 points to enter the ranking of {{courseName}}',
    cat: 'Consigue 20 punts per entrar a la classificació de {{courseName}}',
    eus: '20 puntu gehienekin rankingera sartu {{courseName}}',
    pt: 'Consiga 20 pontos para entrar no ranking de {{courseName}}'
  },
  COMPLETED_TASKS: {
    es: '{{completed}} de {{total}} completadas',
    en: '{{completed}} of {{total}} completed',
    cat: '{{completed}} de {{total}} fetes',
    eus: '{{completed}} osatuak {{total}}',
    pt: '{{completed}} de {{total}} completadas'
  },
  ALL_TASKS_COMPLETED: {
    es: 'Has completado todas las tareas del día 🔥',
    en: 'You have completed all the tasks of the day 🔥',
    cat: 'Has completat totes les tasques del dia 🔥',
    eus: 'Eginak guztiak osatuta daude 🔥',
    pt: 'Você completou todas as tarefas do dia 🔥'
  },
  ALL_TASKS_COMPLETED_SUBTITLE: {
    es: '¡Sigue así para alcanzar tu meta!',
    en: 'Keep going to reach your goal!',
    cat: 'Continua així per aconseguir la teva meta!',
    eus: 'Jarraitu zure helburura iritsi!',
    pt: 'Continue para atingir sua meta!'
  },
  SEE_CALENDAR: {
    es: 'Ver calendario',
    en: 'See calendar',
    cat: 'Veure calendari',
    eus: 'Ikusi kalendarioa',
    pt: 'Ver calendário'
  },
  REPLANIFY: {
    es: 'Replanificar',
    en: 'Replanify',
    cat: 'Replanificar',
    eus: 'Berreplanifikatu',
    pt: 'Replanificar'
  },
  SHOW_MORE: {
    es: 'Mostrar más',
    en: 'Show more',
    cat: 'Mostrar més',
    eus: 'Erakutsi gehiago',
    pt: 'Mostrar mais'
  },
  SHOW_LESS: {
    es: 'Mostrar menos',
    en: 'Show less',
    cat: 'Mostrar menys',
    eus: 'Erakutsi gutxiago',
    pt: 'Mostrar menos'
  },
  REST_DAY_TITLE: {
    es: '¡Día libre!',
    en: 'Rest day!',
    cat: 'Dia de descans!',
    eus: 'Iraupena!',
    pt: 'Dia de descanso!'
  },
  REST_DAY_DESCRIPTION: {
    es: 'Aprovecha para recargar energías o repasar.',
    en: 'Take advantage of the day to recharge or review.',
    cat: 'Utilitza el dia per carregar o repassar.',
    eus: 'Erabili iraupena egiteko.',
    pt: 'Aproveite o dia para recarregar ou revisar.'
  },
  EMPTY_TASKS_TITLE: {
    es: 'Hoy no hay tareas',
    en: 'No tasks pending for today.',
    cat: 'No tasques pendents per avui.',
    eus: 'Ez dituzu gaur eguneko eginak.',
    pt: 'Nenhuma tarefa pendente para hoje.'
  },
  EMPTY_TASKS_DESCRIPTION: {
    es: 'Disfruta del descanso o sigue a tu ritmo.',
    en: 'Enjoy the rest or continue at your pace.',
    cat: 'Disfruta el descans o continua al teu ritme.',
    eus: 'Iraupena jasotu edo jarraitu zure uneko abiadura.',
    pt: 'Aproveite o descanso ou continue ao seu ritmo.'
  },
  DELIVERABLES_TITLE: {
    es: 'Entregas',
    en: 'Pending deliverables',
    cat: 'Entregables pendents',
    eus: 'Entregabideak gordetzen',
    pt: 'Entregáveis'
  },
  NO_DELIVERABLES: {
    es: 'No hay entregas pendientes',
    en: 'No pending deliverables',
    cat: 'No hi ha lliuraments pendents',
    eus: 'Ez dago entregatzeko ezer',
    pt: 'Não há entregas pendentes'
  },
  NOTE: {
    es: 'Nota:',
    en: 'Note:',
    cat: 'Nota:',
    eus: 'Nota:',
    pt: 'Nota:'
  },
  DELIVERED: {
    es: 'Entregado',
    en: 'Delivered',
    cat: 'Lliurat',
    eus: 'Entregatuta',
    pt: 'Entregado'
  },
  IN_REVIEW: {
    es: 'En revisión',
    en: 'In review',
    cat: 'En revisió',
    eus: 'Egiaztatzen',
    pt: 'Em revisão'
  },
  COMPLETED: {
    es: 'Completado',
    en: 'Completed',
    cat: 'Completada',
    eus: 'Osatuta',
    pt: 'Completado'
  },
  EMPTY_DELIVERABLES_TITLE: {
    es: 'Aún no has hecho entregas',
    en: 'You haven’t made any deliveries yet',
    cat: 'Encara no has fet cap lliurament',
    eus: 'Ez dituzu ezer entregatzen',
    pt: 'Ainda não fez entregas'
  },
  EMPTY_DELIVERABLES_DESCRIPTION: {
    es: 'Aquí verás los entregables que envíes para corregir.',
    en: 'Here you will see the deliverables you send to correct.',
    cat: 'Aquí veureu els entregables que envieu per corregir.',
    eus: 'Emaitzak zuzendu dituzun entregabideak ikusi ditzakezu.',
    pt: 'Aqui você verá os entregáveis que enviar para corrigir.'
  },
  PLANNED: {
    es: 'Planificado',
    en: 'Planned',
    cat: 'Planificat',
    eus: 'Planifikatuta',
    pt: 'Planejado'
  },
  REALIZED: {
    es: 'Realizado',
    en: 'Realized',
    cat: 'Realitzat',
    eus: 'Eginak',
    pt: 'Real'
  },
  PROGRESS: {
    es: 'Progreso',
    en: 'Progress',
    cat: 'Progrés',
    eus: 'Progresoa',
    pt: 'Progresso'
  },
  MY_PROGRESS: {
    es: 'Mi progreso',
    en: 'My progress',
    cat: 'El meu progrés',
    eus: 'Nire progresoa',
    pt: 'Meu progresso'
  },
  TOTAL_PROGRESS: {
    es: 'Progreso total',
    en: 'Total progress',
    cat: 'Progrés total',
    eus: 'Progresoa guztia',
    pt: 'Progresso total'
  },
  TOTAL: {
    es: 'Total',
    en: 'Total',
    cat: 'Total',
    eus: 'Guztia',
    pt: 'Total'
  },
  IDEAL_PROGRESS: {
    es: 'Progreso ideal',
    en: 'Ideal progress',
    cat: 'Progrés ideal',
    eus: 'Ideala progresoa',
    pt: 'Progresso ideal'
  },
  STUDY_HOURS: {
    es: 'Horas de estudio',
    en: 'Study hours',
    cat: "Horas d'estudi",
    eus: 'Ikasten den orduak',
    pt: 'Horas de estudo'
  },
  RECOMMENDED: {
    es: 'Recomendado',
    en: 'Recommended',
    cat: 'Recomanat',
    eus: 'Gomendatua',
    pt: 'Recomendado'
  },
  END_DATE: {
    es: 'Fecha de fin',
    en: 'End date',
    cat: 'Data de final',
    eus: 'Amaieraren data',
    pt: 'Data de fim'
  },
  REMAINING_DAYS: {
    es: 'Días restantes',
    en: 'Remaining days',
    cat: 'Dies restants',
    eus: 'Iraupen dituen egunak',
    pt: 'Dias restantes'
  },
  DAYS_one: {
    es: 'día',
    en: 'day',
    cat: 'dia',
    eus: 'egun',
    pt: 'dia'
  },
  DAYS_other: {
    es: 'días',
    en: 'days',
    cat: 'dies',
    eus: 'egunak',
    pt: 'dias'
  },
  LATE: {
    es: 'Atrasado',
    en: 'Late',
    cat: 'Atrasat',
    eus: 'Atrasatua',
    pt: 'Atrasado'
  },
  BIT_LATE: {
    es: 'Ligero retraso',
    en: 'Light delay',
    cat: 'Retard lleuger',
    eus: 'Atzeratze lehia',
    pt: 'Atraso leve'
  },
  ON_TIME: {
    es: 'Al día',
    en: 'On time',
    cat: 'A temps',
    eus: 'On doan',
    pt: 'No atrasado'
  },
  EXCEEDED_PROGRESS_TIP: {
    es: '¡Vas súper! Estás {{percentage}}% por delante de tu plan. Mantén este ritmo para terminar antes de lo previsto.',
    en: 'You have exceeded your ideal progress by {{percentage}}%. Keep this pace to finish before expected.',
    cat: 'Has superat la teva progresió ideal en {{percentage}}%. Mantén aquest ritme per acabar abans de previst.',
    eus: 'Zure ideala progresoa {{percentage}}% gainditu duzu. Jarraitu abiadura hau osatzeko.',
    pt: 'Você ultrapassou seu progresso ideal em {{percentage}}%. Continue com este ritmo para terminar antes do previsto.'
  },
  LATE_PROGRESS_TIP: {
    es: 'Te recomendamos ir un poco más rápido para llegar a tiempo o cambiar la fecha de fin.',
    en: 'We recommend you to go a bit faster to reach on time or change the end date.',
    cat: 'Recomanem que aneu un poc més ràpid per arribar a temps o canviar la data de final.',
    eus: 'Gomendatzen dugu zure progresoa pixka bat azkarrago joan eta amaieraren data aldatu.',
    pt: 'Recomendamos que vá para um pouco mais rápido para chegar a tempo ou alterar a data de fim.'
  },
  BIT_LATE_PROGRESS_TIP: {
    es: 'Estás un poco por debajo de tu plan ideal. Dedica más tiempo a los cursos atrasados para ponerte al día.',
    en: 'You are a bit below your ideal plan. Dedicate more time to the delayed courses to catch up.',
    cat: 'Estàs un poc per sota de la teva plan ideal. Dedica més temps als cursos aturats per posar-te al dia.',
    eus: 'Zure ideala planoaren azpian dagozu. Atzeratutako ikastarrenekin gehiago lan egin eta atzeratuak egin.',
    pt: 'Você está um pouco abaixo do seu plano ideal. Dedique mais tempo aos cursos atrasados para se colocar no dia.'
  },
  ON_TIME_PROGRESS_TIP: {
    es: 'Vas bien encaminado. Continúa con tu ritmo actual para completar tu estudio a tiempo.',
    en: 'You are on track. Continue with your current pace to complete your study on time.',
    cat: 'Estàs a punt. Continua amb el teu ritme actual per completar el teu estudi a temps.',
    eus: 'Zure progresoa on doan dago. Jarraitu zure uneko abiadura eta osatzeko.',
    pt: 'Você está no caminho certo. Continue com seu ritmo atual para completar seu estudo no tempo.'
  },
  NOT_STARTED_PROGRESS_TIP: {
    es: 'Sigue el ritmo que te proponemos para terminar tu estudio a tiempo.',
    en: 'Follow the pace we propose to finish your study on time.',
    cat: 'Segueix el ritme que et proposem per acabar el teu estudi a temps.',
    eus: 'Jarraitu abiadura hau osatzeko.',
    pt: 'Siga o ritmo que propomos para terminar seu estudo no tempo.'
  },
  [ESectionTrackStatus.KNOWN]: {
    es: 'Me lo sé',
    en: 'I know it',
    cat: 'Ho sé',
    eus: 'Ezagutzen ditut',
    pt: 'Já sei'
  },
  [ESectionTrackStatus.REVISED]: {
    es: 'Falta repaso',
    en: 'Need review',
    cat: 'Cal revisar',
    eus: 'Egiaztatu behar da',
    pt: 'Precisa de revisão'
  },
  [ESectionTrackStatus.SUMMARISED]: {
    es: 'Resumido',
    en: 'Summarized',
    cat: 'Resumit',
    eus: 'Laburpena',
    pt: 'Resumido'
  },
  [ESectionTrackStatus.SEEN]: {
    es: 'Visto',
    en: 'Seen',
    cat: 'Vist',
    eus: 'Ikusi da',
    pt: 'Visto'
  },
  [ESectionTrackStatus.NOT_STARTED]: {
    es: 'Pendiente',
    en: 'Pending',
    cat: 'Pendent',
    eus: 'Gordetzen',
    pt: 'Pendente'
  },
  [ESectionTrackStatus.STUDIED]: {
    es: 'Estudiado',
    en: 'Studied',
    cat: 'Estudiat',
    eus: 'Ikasten da',
    pt: 'Estudado'
  },
  SEEN_CLASSES: {
    es: 'Clases vistas',
    en: 'Seen classes',
    cat: 'Classes vistes',
    eus: 'Ikusi dituzun ikastarren kopurua',
    pt: 'Aulas vistas'
  },
  NOT_SEEN_CLASSES: {
    es: 'Clases pendientes',
    en: 'Pending classes',
    cat: 'Classes pendents',
    eus: 'Ikastarren gordetzen',
    pt: 'Aulas pendentes'
  },
  COMPLETED_DELIVERABLES: {
    es: 'Entregables completados',
    en: 'Completed deliverables',
    cat: 'Entregables completats',
    eus: 'Entregabideak osatuta',
    pt: 'Entregáveis completados'
  },
  STREAK_TITLE_one: {
    es: '{{count}} día de racha',
    en: '{{count}} day of streak',
    cat: '{{count}} dia de racha',
    eus: '{{count}} egun jarraian',
    pt: '{{count}} dia de racha'
  },
  STREAK_TITLE_other: {
    es: '{{count}} días de racha',
    en: '{{count}} days of streak',
    cat: '{{count}} dies de racha',
    eus: '{{count}} egun jarraian',
    pt: '{{count}} dias de racha'
  },
  STREAK_DESCRIPTION: {
    es: 'Completa una actividad cada día para mantener tu racha y aumentar tu multiplicador de puntos.',
    en: 'Complete an activity every day to keep your streak and increase your points multiplier.',
    cat: 'Completa una activitat cada dia per mantenir la teva racha i augmentar el teu multiplicador de punts.',
    eus: 'Egin bat aktibitate egunero bakoitzeko zure racharen mantentzeko eta puntuen multiplikatzailearen gehitzeko.',
    pt: 'Complete uma atividade todos os dias para manter sua racha e aumentar seu multiplicador de pontos.'
  },
  NEXT_TASK: {
    es: 'Siguiente tarea',
    en: 'Next task',
    cat: 'Tasca següent',
    eus: 'Hurrengo eginak',
    pt: 'Próxima tarefa'
  },
  NEW_DASHBOARD_MODAL_TITLE: {
    es: '✨ Estrenamos nuevo look ✨',
    en: '✨ We are launching a new look ✨',
    cat: '✨ Estem llançant un nou look ✨',
    eus: '✨ Berri baten lanzatzen ✨',
    pt: '✨ Estamos lançando um novo visual ✨'
  },
  NEW_DASHBOARD_MODAL_SUBTITLE: {
    es: 'Hemos rediseñado tu pantalla de inicio para que sea más ágil, intuitiva y moderna. ¡Échale un ojo a los cambios!',
    en: 'We have redesigned your home screen to make it more intuitive and modern. Take a look at the changes!',
    cat: 'Hem redissenyat la teva pantalla d’inici per a que sigui més intuïtiva i moderna. Mira els canvis!',
    eus: 'Egin dagoen berririk berriro, eta berririk berririk egin daiteke. Egin berririk berririk!',
    pt: 'Re-desenhamos a sua tela inicial para tornar mais intuitiva e moderna. Veja os novos recursos!'
  },
  WELCOME_MESSAGE: {
    es: '✨ Ya estás dentro del campus ✨',
    en: '✨ You are inside the campus ✨',
    cat: '✨ Estàs dins del campus ✨',
    eus: '✨ Zure ikastararen barruan ✨',
    pt: '✨ Você está dentro do campus ✨'
  },
  WELCOME_MESSAGE_DESCRIPTION: {
    es: '¿Damos un tour rápido para que sepas donde está todo?',
    en: 'Do we give you a quick tour to show you where everything is?',
    cat: 'Volem fer-vos un tour ràpid per a que veieu on està tot?',
    eus: 'Zure ikastararen ezagutza guztia erakutsi nahi dugu?',
    pt: 'Queremos fazer um tour rápido para que veja onde está tudo?'
  },
  NOT_NOW: {
    es: 'Ahora no',
    en: 'Not now',
    cat: 'No ara',
    eus: 'Ez orain',
    pt: 'Não agora'
  },
  TAKE_A_TOUR: {
    es: 'Hacer el tour',
    en: 'Make the tour',
    cat: 'Fes el tour',
    eus: 'Egin berririk bat',
    pt: 'Fazer o tour'
  },
  [`${EUserFirstStep.CLASS_SCHEDULED}_TITLE`]: {
    es: '🗓️ Apúntate a una clase',
    en: '🗓️ Inscribe to a class',
    cat: '🗓️ Apunta´t a una classe',
    eus: '🗓️ Klase bat apuntatu',
    pt: '🗓️ Inscreva-se numa aula'
  },
  [`${EUserFirstStep.CLASS_SCHEDULED}_DESCRIPTION`]: {
    es: 'Añade una clase a tu calendario.',
    en: 'Add a class to your calendar.',
    cat: 'Afegeix una classe al teu calendari.',
    eus: 'Klase bat gehitu zure kalendariara.',
    pt: 'Adicione uma aula ao seu calendário.'
  },
  [`${EUserFirstStep.CLASS_SCHEDULED}_BUTTON`]: {
    es: 'Ver calendario',
    en: 'See calendar',
    cat: 'Veure calendari',
    eus: 'Ikusi kalendarioa',
    pt: 'Ver calendário'
  },
  [`${EUserFirstStep.TASK_COMPLETED}_TITLE`]: {
    es: '✅ Completa una tarea',
    en: '✅ Complete a task',
    cat: '✅ Completa una tasca',
    eus: '✅ Amaitu eginkizuna',
    pt: '✅ Conclua uma tarefa'
  },
  [`${EUserFirstStep.TASK_COMPLETED}_DESCRIPTION`]: {
    es: 'Completa tu primera actividad.',
    en: 'Complete your first task.',
    cat: 'Completa la teva primera activitat.',
    eus: 'Egin zure lehen jarduera.',
    pt: 'Complete sua primeira tarefa.'
  },
  [`${EUserFirstStep.TASK_COMPLETED}_BUTTON`]: {
    es: 'Empezar',
    en: 'Start',
    cat: 'Comença',
    eus: 'Hasi',
    pt: 'Começar'
  },
  [`${EUserFirstStep.INTRODUCTION_VIEWED}_TITLE`]: {
    es: '🎬 Mira la introducción',
    en: '🎬 Watch the introduction',
    cat: '🎬 Mira la introducció',
    eus: '🎬 Ikusi sarrera',
    pt: '🎬 Veja a introdução'
  },
  [`${EUserFirstStep.INTRODUCTION_VIEWED}_DESCRIPTION`]: {
    es: 'Conoce cómo va tu formación.',
    en: 'Get to know your training.',
    cat: 'Conèix la teva formació.',
    eus: 'Zure ikastaroa ezagutzeko.',
    pt: 'Conheça sua formação.'
  },
  [`${EUserFirstStep.INTRODUCTION_VIEWED}_BUTTON`]: {
    es: 'Ver introducción',
    en: 'See intro',
    cat: 'Veure introducció',
    eus: 'Sarrera ikusi',
    pt: 'Ver introdução'
  },
  [`${EUserFirstStep.ACTIVITY_COMPLETED}_TITLE`]: {
    es: '📘 Completa una lección',
    en: '📘 Complete a lesson',
    cat: '📘 Completa una lliçó',
    eus: '📘 Amaitu ikastaroko lekzio bat',
    pt: '📘 Conclua uma lição'
  },
  [`${EUserFirstStep.ACTIVITY_COMPLETED}_DESCRIPTION`]: {
    es: 'Empieza a estudiar el temario.',
    en: 'Start studying the syllabus.',
    cat: 'Comença a estudiar el temari.',
    eus: 'Ikastaroa egin',
    pt: 'Comece a estudar o programa.'
  },
  [`${EUserFirstStep.ACTIVITY_COMPLETED}_BUTTON`]: {
    es: 'Empezar',
    en: 'Start',
    cat: 'Comença',
    eus: 'Hasi',
    pt: 'Começar'
  },
  [`${EUserFirstStep.QUIZ_COMPLETED}_TITLE`]: {
    es: '🎯 Haz un test',
    en: '🎯 Take a quiz',
    cat: '🎯 Fes un test',
    eus: '🎯 Egin test bat',
    pt: '🎯 Faça um teste'
  },
  [`${EUserFirstStep.QUIZ_COMPLETED}_DESCRIPTION`]: {
    es: 'Pon a prueba lo que sabes.',
    en: 'Test your knowledge.',
    cat: 'Posa a prova els teus coneixements.',
    eus: 'Zure ezagutzak probatzeko.',
    pt: 'Teste seus conhecimentos.'
  },
  [`${EUserFirstStep.QUIZ_COMPLETED}_BUTTON`]: {
    es: 'Practicar',
    en: 'Practice',
    cat: 'Practicar',
    eus: 'Egin praktika',
    pt: 'Praticar'
  },
  [`${EUserFirstStep.PROFILE_COMPLETED}_TITLE`]: {
    es: '👤 Completa tu perfil',
    en: '👤 Complete your profile',
    cat: '👤 Completa el teu perfil',
    eus: '👤 Zure profila betetu',
    pt: '👤 Complete o seu perfil'
  },
  [`${EUserFirstStep.PROFILE_COMPLETED}_DESCRIPTION`]: {
    es: 'Sube tu foto y cuenta algo sobre ti.',
    en: 'Upload your photo and tell us something about you.',
    cat: 'Carrega la teva foto i diu-nos alguna cosa sobre tu.',
    eus: 'Zure irudia eta zure burua azaldu',
    pt: 'Carregue a sua foto e conte-nos algo sobre você.'
  },
  [`${EUserFirstStep.PROFILE_COMPLETED}_BUTTON`]: {
    es: 'Editar perfil',
    en: 'Edit profile',
    cat: 'Editar perfil',
    eus: 'Profila editatu',
    pt: 'Editar perfil'
  },
  CHAT_CONTACT_LABEL: {
    es: 'Chat: clica en el botón verde de la esquina inferior derecha.',
    en: 'Chat: click on the green button in the lower right corner.',
    cat: 'Chat: fes clic en el botó de la cantonada inferior dreta.',
    eus: 'Chat: egin klik leihoaren beheko erdian.',
    pt: 'Chat: clique no botão verde na parte inferior direita.'
  },
  NO_MORE_TASKS: {
    es: 'No hay más tareas planificadas',
    en: 'No more tasks planned',
    cat: 'No hi ha més tasques planificades',
    eus: 'Ez dago gehiago eginak',
    pt: 'Não há mais tarefas planejadas'
  },
  MY_COURSES: {
    es: 'Mis cursos',
    en: 'My courses',
    cat: 'Els meus cursos',
    eus: 'Nire ikastarak',
    pt: 'Meus cursos'
  },
  MY_FEATURED_COURSES: {
    es: 'Mis cursos destacados',
    en: 'My featured courses',
    cat: 'Els meus cursos destacats',
    eus: 'Nire ikastarak garrantzitsuak',
    pt: 'Meus cursos destacados'
  },
  COMPLETE_YOUR_PROFILE_FP: {
    es: '¡Completa tu perfil!',
    en: 'Complete your profile!',
    cat: 'Completa el teu perfil!',
    eus: 'Zure profila betetu!',
    pt: 'Complete o seu perfil!'
  },
  COMPLETE_YOUR_PROFILE_FP_SUBTITLE: {
    es: 'Con el objetivo de asegurar una correcta gestión administrativa, es obligatorio completar tu perfil personal con los datos adicionales solicitados.',
    en: 'In order to ensure proper administrative management, it is mandatory to complete your personal profile with the additional data requested.',
    cat: 'Per a garantir una gestió administrativa correcta, és obligatori completar el teu perfil personal amb les dades addicionals sol·licitades.',
    eus: 'Administratiboki zuzena mantentzeko, zure pertsonala profila betetu eta jarraitu',
    pt: 'Para garantir uma gestão administrativa correta, é obrigatório completar o seu perfil pessoal com os dados adicionais solicitados.'
  },
  COMPLETE_YOUR_PROFILE_FP_DESCRIPTION: {
    es: '(<span>*</span>) Todos los campos marcados con asterisco son obligatorios.',
    en: '(<span>*</span>) All fields marked with an asterisk are required.',
    cat: '(<span>*</span>) Tots els camps marcats amb un asterisc són obligatoris.',
    eus: '(<span>*</span>) Zutabe guztien izenak asteak sartu behar dira.',
    pt: '(<span>*</span>) Todos os campos marcados com asterisco são obrigatórios.'
  },
  COMPLETE_YOUR_PROFILE_FP_WARNING_TITLE: {
    es: 'Es muy importante que verifiques tu información antes de enviarla.',
    en: 'It is very important that you verify your information before sending it.',
    cat: 'És molt important que verificis la teva informació abans de enviar-la.',
    eus: 'Informazioa zuzendu behar duzu bidaltzen aurretik.',
    pt: 'Verifique suas informações antes de enviá-las.'
  },
  COMPLETE_YOUR_PROFILE_FP_WARNING_DESCRIPTION: {
    es: 'Si necesitas modificar algún dato más tarde, deberás contactar al equipo académico para solicitar la edición de la información.',
    en: 'If you need to modify any information later, you will need to contact the academic team to request the editing of the information.',
    cat: 'Si necessites modificar qualsevol informació més tard, hauràs de contactar amb el equip acadèmic per a sol·licitar la modificació de la informació.',
    eus: 'Informazio bat aldatu nahi baduzu, zure ikastararen ekipearekin harremanetan jarri behar duzu.',
    pt: 'Se precisar modificar alguma informação posteriormente, deverá contactar o equipo académico para solicitar a modificação da informação.'
  },
  PROFILE_UPDATED_SUCCESSFULLY: {
    es: 'Perfil completado correctamente',
    en: 'Profile completed successfully',
    cat: 'Perfil completat correctament',
    eus: 'Profila osatuta',
    pt: 'Perfil completado com sucesso'
  },
  ERROR_UPDATING_PROFILE: {
    es: 'Error al completar el perfil',
    en: 'Error completing profile',
    cat: 'Error en completar el perfil',
    eus: 'Errorea profila osatzen',
    pt: 'Erro ao completar o perfil'
  },
  COMPLETE_YOUR_PROFILE_FP_BANNER_DESCRIPTION: {
    es: 'Con el objetivo de asegurar una correcta gestión administrativa, es obligatorio completar tu perfil personal con los datos adicionales solicitados.',
    en: 'In order to ensure proper administrative management, it is mandatory to complete your personal profile with the additional data requested.',
    cat: 'Per a garantir una gestió administrativa correcta, és obligatori completar el teu perfil personal amb les dades addicionals sol·licitades.',
    eus: 'Administratiboki zuzena mantentzeko, zure profil pertsonala bete behar duzu eskatutako datu gehigarriekin.',
    pt: 'Para garantir uma gestão administrativa correta, é obrigatório completar o seu perfil pessoal com os dados adicionais solicitados.'
  },
  COMPLETE_YOUR_PROFILE_FP_BANNER_BUTTON: {
    es: 'Completar perfil',
    en: 'Complete profile',
    cat: 'Completar perfil',
    eus: 'Profila osatu',
    pt: 'Completar perfil'
  },
  DISCARD_CHANGES_TITLE: {
    es: '¿Descartar cambios?',
    en: 'Discard changes?',
    cat: 'Descartar canvis?',
    eus: 'Aldaketak baztertu?',
    pt: 'Descartar alterações?'
  },
  DISCARD_CHANGES_DESCRIPTION: {
    es: 'Si cierras esta ventana, se cancelarán todos los cambios no guardados.',
    en: 'If you close this window, all unsaved changes will be cancelled.',
    cat: 'Si tanques aquesta finestra, es cancel·laran tots els canvis no desats.',
    eus: 'Leiho hau ixten baduzu, gorde gabeko aldaketak ezabatuko dira.',
    pt: 'Se fechar esta janela, todas as alterações não guardadas serão canceladas.'
  },
  CLOSE_AND_DISCARD: {
    es: 'Cerrar y descartar',
    en: 'Close and discard',
    cat: 'Tancar i descartar',
    eus: 'Itxi eta baztertu',
    pt: 'Fechar e descartar'
  },
  KEEP_EDITING: {
    es: 'Seguir editando',
    en: 'Keep editing',
    cat: 'Seguir editant',
    eus: 'Editatzen jarraitu',
    pt: 'Continuar editando'
  },
  GENERAL_INFORMATION: {
    es: 'Información general',
    en: 'General information',
    cat: 'Informació general',
    eus: 'Informazio orokorra',
    pt: 'Informação geral'
  },
  NAME: {
    es: 'Nombre',
    en: 'Name',
    cat: 'Nom',
    eus: 'Izena',
    pt: 'Nome'
  },
  NAME_PLACEHOLDER: {
    es: 'Introduce tu nombre',
    en: 'Enter your name',
    cat: 'Introdueix el teu nom',
    eus: 'Sartu zure izena',
    pt: 'Introduza o seu nome'
  },
  REQUIRED_NAME: {
    es: 'Por favor, completa el campo Nombre',
    en: 'Please complete the Name field',
    cat: 'Si us plau, completa el camp Nom',
    eus: 'Mesedez, bete Izena eremua',
    pt: 'Por favor, complete o campo Nome'
  },
  FIRST_SURNAME: {
    es: 'Primer apellido',
    en: 'First surname',
    cat: 'Primer cognom',
    eus: 'Lehen abizena',
    pt: 'Primeiro apelido'
  },
  FIRST_SURNAME_PLACEHOLDER: {
    es: 'Introduce tu primer apellido',
    en: 'Enter your first surname',
    cat: 'Introdueix el teu primer cognom',
    eus: 'Sartu zure lehen abizena',
    pt: 'Introduza o seu primeiro apelido'
  },
  REQUIRED_FIRST_SURNAME: {
    es: 'Por favor, completa el campo primer apellido',
    en: 'Please complete the First surname field',
    cat: 'Si us plau, completa el camp Primer cognom',
    eus: 'Mesedez, bete Lehen abizena eremua',
    pt: 'Por favor, complete o campo Primeiro apelido'
  },
  SECOND_SURNAME: {
    es: 'Segundo apellido',
    en: 'Second surname',
    cat: 'Segon cognom',
    eus: 'Bigarren abizena',
    pt: 'Segundo apelido'
  },
  SECOND_SURNAME_PLACEHOLDER: {
    es: 'Introduce tu segundo apellido',
    en: 'Enter your second surname',
    cat: 'Introdueix el teu segon cognom',
    eus: 'Sartu zure bigarren abizena',
    pt: 'Introduza o seu segundo apelido'
  },
  PHONE: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  PHONE_PLACEHOLDER: {
    es: 'Teléfono',
    en: 'Phone',
    cat: 'Telèfon',
    eus: 'Telefonoa',
    pt: 'Telefone'
  },
  REQUIRED_PHONE: {
    es: 'Por favor, completa el campo Teléfono',
    en: 'Please complete the Phone field',
    cat: 'Si us plau, completa el camp Telèfon',
    eus: 'Mesedez, bete Telefono eremua',
    pt: 'Por favor, complete o campo Telefone'
  },
  IDENTIFICATION_DOCUMENT: {
    es: 'Documento de identificación',
    en: 'Identification document',
    cat: "Document d'identificació",
    eus: 'Identifikazio dokumentua',
    pt: 'Documento de identificação'
  },
  REQUIRED_DOCUMENT_TYPE: {
    es: 'Por favor, selecciona el tipo de documento',
    en: 'Please select the document type',
    cat: 'Si us plau, selecciona el tipus de document',
    eus: 'Mesedez, hautatu dokumentu mota',
    pt: 'Por favor, selecione o tipo de documento'
  },
  REQUIRED_DOCUMENT_NUMBER: {
    es: 'Por favor, introduce el número de documento',
    en: 'Please enter the document number',
    cat: 'Si us plau, introdueix el número de document',
    eus: 'Mesedez, sartu dokumentu zenbakia',
    pt: 'Por favor, introduza o número do documento'
  },
  DOCUMENT_NUMBER_PLACEHOLDER: {
    es: 'Número de documento',
    en: 'Document number',
    cat: 'Número de document',
    eus: 'Dokumentu zenbakia',
    pt: 'Número do documento'
  },
  NATIONALITY: {
    es: 'Nacionalidad',
    en: 'Nationality',
    cat: 'Nacionalitat',
    eus: 'Nazionalitatea',
    pt: 'Nacionalidade'
  },
  REQUIRED_NATIONALITY: {
    es: 'Por favor, selecciona tu nacionalidad',
    en: 'Please select your nationality',
    cat: 'Si us plau, selecciona la teva nacionalitat',
    eus: 'Mesedez, hautatu zure nazionalitatea',
    pt: 'Por favor, selecione a sua nacionalidade'
  },
  SELECT_OPTION: {
    es: 'Selecciona una opción',
    en: 'Select an option',
    cat: 'Selecciona una opció',
    eus: 'Hautatu aukera bat',
    pt: 'Selecione uma opção'
  },
  BIRTH_INFORMATION: {
    es: 'Información de nacimiento',
    en: 'Birth information',
    cat: 'Informació de naixement',
    eus: 'Jaiotze informazioa',
    pt: 'Informação de nascimento'
  },
  BIRTH_DATE: {
    es: 'Fecha de nacimiento',
    en: 'Date of birth',
    cat: 'Data de naixement',
    eus: 'Jaiotze data',
    pt: 'Data de nascimento'
  },
  REQUIRED_BIRTH_DATE: {
    es: 'Por favor, indica tu fecha de nacimiento',
    en: 'Please enter your date of birth',
    cat: 'Si us plau, indica la teva data de naixement',
    eus: 'Mesedez, adierazi zure jaiotze data',
    pt: 'Por favor, informe sua data de nascimento'
  },
  SELECT_BIRTH_DATE: {
    es: 'Selecciona tu fecha de nacimiento',
    en: 'Select your date of birth',
    cat: 'Selecciona la teva data de naixement',
    eus: 'Hautatu zure jaiotze data',
    pt: 'Selecione sua data de nascimento'
  },
  SEX: {
    es: 'Sexo',
    en: 'Sex',
    cat: 'Sexe',
    eus: 'Sexua',
    pt: 'Sexo'
  },
  REQUIRED_SEX: {
    es: 'Por favor, selecciona el sexo',
    en: 'Please select the sex',
    cat: 'Si us plau, selecciona el sexe',
    eus: 'Mesedez, hautatu sexua',
    pt: 'Por favor, selecione o sexo'
  },
  BIRTH_COUNTRY: {
    es: 'País de nacimiento',
    en: 'Birth country',
    cat: 'País de naixement',
    eus: 'Jaiotze herrialdea',
    pt: 'País de nascimento'
  },
  REQUIRED_BIRTH_COUNTRY: {
    es: 'Por favor, selecciona tu país de nacimiento',
    en: 'Please select your birth country',
    cat: 'Si us plau, selecciona el teu país de naixement',
    eus: 'Mesedez, hautatu zure jaiotze herrialdea',
    pt: 'Por favor, selecione seu país de nascimento'
  },
  PROVINCE: {
    es: 'Provincia',
    en: 'Province',
    cat: 'Província',
    eus: 'Probintzia',
    pt: 'Província'
  },
  REQUIRED_PROVINCE: {
    es: 'Por favor, selecciona la provincia',
    en: 'Please select the province',
    cat: 'Si us plau, selecciona la província',
    eus: 'Mesedez, hautatu probintzia',
    pt: 'Por favor, selecione a província'
  },
  MUNICIPALITY: {
    es: 'Municipio',
    en: 'Municipality',
    cat: 'Municipi',
    eus: 'Udalerria',
    pt: 'Município'
  },
  REQUIRED_MUNICIPALITY: {
    es: 'Por favor, completa el municipio',
    en: 'Please complete the municipality',
    cat: 'Si us plau, completa el municipi',
    eus: 'Mesedez, hautatu udalerria',
    pt: 'Por favor, complete o município'
  },
  LOCALITY: {
    es: 'Localidad',
    en: 'Locality',
    cat: 'Localitat',
    eus: 'Herria',
    pt: 'Localidade'
  },
  REQUIRED_LOCALITY: {
    es: 'Por favor, completa la localidad',
    en: 'Please complete the locality',
    cat: 'Si us plau, completa la localitat',
    eus: 'Mesedez, hautatu herria',
    pt: 'Por favor, complete a localidade'
  },
  FOREIGN_BIRTH_LOCALITY: {
    es: 'Localidad de nacimiento extranjera',
    en: 'Foreign birth locality',
    cat: 'Localitat de naixement estrangera',
    eus: 'Atzerriko jaiotze herria',
    pt: 'Localidade de nascimento estrangeira'
  },
  REQUIRED_FOREIGN_BIRTH_LOCALITY: {
    es: 'Por favor, completa la localidad de nacimiento',
    en: 'Please complete the birth locality',
    cat: 'Si us plau, completa la localitat de naixement',
    eus: 'Mesedez, sartu jaiotze herria',
    pt: 'Por favor, complete a localidade de nascimento'
  },
  FOREIGN_BIRTH_LOCALITY_PLACEHOLDER: {
    es: 'Completa la localidad de nacimiento',
    en: 'Complete the birth locality',
    cat: 'Completa la localitat de naixement',
    eus: 'Sartu jaiotze herria',
    pt: 'Complete a localidade de nascimento'
  },
  RESIDENCE_INFORMATION: {
    es: 'Información de residencia',
    en: 'Residence information',
    cat: 'Informació de residència',
    eus: 'Bizitegi informazioa',
    pt: 'Informação de residência'
  },
  STREET_TYPE: {
    es: 'Tipo de vía',
    en: 'Street type',
    cat: 'Tipus de via',
    eus: 'Kale mota',
    pt: 'Tipo de via'
  },
  REQUIRED_STREET_TYPE: {
    es: 'El tipo de vía es obligatorio',
    en: 'Street type is required',
    cat: 'El tipus de via és obligatori',
    eus: 'Kale mota beharrezkoa da',
    pt: 'O tipo de via é obrigatório'
  }
};
